export default "__VITE_ASSET__BY4RLzT6__"